import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNewApiInstance } from "../../services/api.js";

export const getTariffs = createAsyncThunk(
  "tariffs/getTariffsList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get("/api/v1/tariffs/");

      console.log("getTariffs response:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail,
      });
    }
  }
);

// Generate Stripe Invoice +
export const generateInvoice = createAsyncThunk(
  "tariffs/generateInvoice",
  async (invoiceData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        "/api/v1/invoices/create/stripe",
        invoiceData
      );
      console.log("generateInvoice:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail,
      });
    }
  }
);

// Generate Balane Top-up Invoice +
export const generateBalanceTopupInvoice = createAsyncThunk(
  "tariffs/generateBalanceTopupInvoice",
  async (invoiceData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        "/api/v1/payments/stripe/balance/topup",
        invoiceData
      );
      console.log("generateBalanceTopupInvoice:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail,
      });
    }
  }
);

// Get Services Usage Prices +
export const getServicesUsagePrices = createAsyncThunk(
  "tariffs/getServicesUsagePrices",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        "/api/v1/service-usage/prices"
      );
      console.log("getServicesUsagePrices:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail,
      });
    }
  }
);

// Get Balance Usage Details +
export const getBalanceUsageDetails = createAsyncThunk(
  "tariffs/getBalanceUsageDetails",
  async ({ workshopId, date_from, date_to }, thunkAPI) => {
    try {
      const params = {};
      if (date_from) params.date_from = date_from;
      if (date_to) params.date_to = date_to;

      const response = await axiosNewApiInstance.get(
        `/api/v1/service-usage/logs/${workshopId}`,
        { params }
      );
      console.log("getBalanceUsageDetails:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail,
      });
    }
  }
);
